// extracted by mini-css-extract-plugin
export default {"category":"yS3Nd","categoryItem":"pR5H5","categoryLabel":"XeZhr","categoryIcon":"Dc0cl"};